

export default function getGridIndexListItemByXYOrThrow<T>(
  gridWidth: number,
  gridHeight: number,
  list: Array<T>,
  x: number,
  y: number,
): T {
  if ((x >= 0 && x < gridWidth && y >= 0 && y < gridHeight)) {
    const gridIndex = x + (y * gridWidth)
    return list[gridIndex]
  }
  throw new Error(`(${x}, ${y}) is out of bounds for grid of size ${gridWidth}x${gridHeight}`)
}